// extracted by mini-css-extract-plugin
export default {"req":"PasswordRequirements_req__6a5GU"};